import type { ChangeEvent } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

interface Props {
  open: boolean;
  value: string;
  hasLegalBorder: boolean;
  hasBuildableBorder: boolean;
  modalStyle: object;
  onClose: () => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onConfirm: () => void;
}

const AnalysisAreaTypeModal = ({
  open,
  value,
  hasLegalBorder,
  hasBuildableBorder,
  modalStyle,
  onClose,
  onChange,
  onConfirm,
}: Props) => (
  <Modal open={open} onClose={onClose} className="custom-modal">
    <Box sx={{ ...modalStyle, width: 'auto', border: 'none', borderRadius: '4px' }}>
      <Typography variant="h6" component="h2">
        Please choose one of the options.
      </Typography>
      <RadioGroup value={value} onChange={onChange} sx={{ mt: 1 }}>
        {hasLegalBorder && (
          <FormControlLabel
            className="radio-row"
            value="asTheLegalBorder"
            control={<Radio />}
            label="The analysis area will be the same as the property area."
          />
        )}
        {hasBuildableBorder && (
          <FormControlLabel
            className="radio-row"
            value="asTheBuildableBorder"
            control={<Radio />}
            label="The analysis area will be the same as the buildable area."
          />
        )}
      </RadioGroup>
      <br />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <Button variant="contained" className="modal-no-btn" onClick={onClose}>
          CANCEL
        </Button>
        <Button variant="contained" className="modal-yes-btn" onClick={onConfirm}>
          Ok
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default AnalysisAreaTypeModal;
